<div
  class="relative flex h-[16.2rem] w-full max-w-[77.2rem] shrink-0 items-center justify-start overflow-hidden rounded-[2rem] bg-[#233366] bg-[linear-gradient(0deg,rgba(46,78,159,0.70)_0%,rgba(35,46,102,0.70)_106.85%)] p-[1.6rem] pb-[1.2rem] lg:h-[12.5rem] lg:p-[1rem] lg:pb-[0.6rem]"
>
  <img
    class="pointer-events-none absolute bottom-0 left-0 z-[1] h-auto w-full max-w-[26rem] flex-shrink-0 lg:max-w-[16rem]"
    src="/assets/images/main/banners/bonuses/gifts.png"
    alt=""
  />
  <img
    class="pointer-events-none absolute bottom-0 left-0 h-auto w-full max-w-[26rem] flex-shrink-0 lg:max-w-[16rem]"
    src="/assets/images/main/banners/bonuses/shadow.webp"
    alt=""
  />
  <div
    class="z-[3] flex h-full w-[20rem] flex-shrink-0 items-start justify-start pl-[0.8rem] pt-[0.8rem] lg:w-[12rem] lg:pl-[0.2rem] lg:pt-[0.2rem]"
  >
    <div class="flex max-w-[14.5rem] flex-col items-start justify-start space-y-[0.3rem]">
      <span
        class="text-[1.4rem] font-450 leading-[2rem] text-[#FFDB95] lg:text-[1.1rem] lg:leading-[1.4rem]"
        i18n="@@main.bonusbanner.winSkins"
        >Выигрывай скины</span
      >
      <span
        class="text-[1.6rem] font-450 leading-[2.4rem] text-white lg:text-[1.3rem] lg:leading-[1.8rem]"
        i18n="@@main.bonusbanner.title"
        >Ежедневные бонусы</span
      >
    </div>
  </div>

    <div class="flex h-full w-full items-start justify-start overflow-auto">
      <swiper
        class="flex h-full w-full items-center justify-center space-x-[0.4rem]"
        [config]="{
          slidesPerView: 'auto'
        }"
        #swiperRef
      >
        @if (isLoading() ? preloadRewards : state.rewards(); as slides) {
          @for (reward of slides; track reward?.id; let i = $index) {
            <ng-template swiperSlide>
              <bonus-item
                [reward]="reward"
                [isLastAndActive]="isLastAndActive(state.rewards(), reward?.id)"
                [isFirstElement]="i === 0"
                [isLastElement]="i === slides.length - 1"
                [avatars]="state.avatars()"
                [loggedUser]="authState.user()"
                [isAuthenticated]="authState.isAuthenticated()"
              />
            </ng-template>
          }
        }
      </swiper>
    </div>
  <img
    class="pointer-events-none absolute right-0 top-0 !mt-0 h-full max-h-full w-[10.6rem]"
    src="/assets/images/main/banners/bonuses/right-shadow.webp"
    alt=""
  />
</div>
